"use client";

import { useEffect } from "react";
import { HUB_AUTH_NEXT_COOKIE_NAME, isSafeHubRelativePath } from "@/lib/utils/safe-redirect-path";
const MAX_AGE_SEC = 600;

/**
 * Persists a post-login redirect for OAuth round-trips (e.g. Google) where callback URL cannot carry query params.
 */
export function SetAuthRedirectCookie({ path }: { path: string | null | undefined }) {
  useEffect(() => {
    if (!path || !isSafeHubRelativePath(path)) {
      return;
    }
    const segments = [
      `${HUB_AUTH_NEXT_COOKIE_NAME}=${encodeURIComponent(path.trim())}`,
      "Path=/",
      `Max-Age=${MAX_AGE_SEC}`,
      "SameSite=Lax",
    ];
    if (window.location.protocol === "https:") {
      segments.push("Secure");
    }
    document.cookie = segments.join("; ");
  }, [path]);
  return null;
}
